import React, { useEffect, useRef } from 'react';

const ToastMessage = ({
    message,
    type = 'success',
    show,
    onClose,
    className = '',
    position = 'fixed'
}) => {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (show) {
            const timer = setTimeout(() => {
                onCloseRef.current();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [show]);

    if (!show) return null;

    const background = type === 'success' ? 'bg-[#d9f7e6] border-[#7ae2d1]' : 'bg-[#f7eee6] border-[#ffb580]';

    const positionClasses =
        position === 'fixed'
            ? `fixed top-5 left-0 right-0 z-[9999] h-16 flex items-center justify-center py-2 shadow-md border border-2 font-medium text-black w-[95%]  mx-auto rounded-lg animate-slide-in-right ${background}`
            : position === 'absolute'
                ? `absolute -top-5 left-1/2 transform -translate-x-1/2 z-50 text-critical py-2 text-nowrap`
                : '';

    return (
        <div
            className={`${positionClasses} px-4 rounded flex gap-6  ${className}`}
            data-testid="toast-message"
        >

            {type === 'success' ? (
                <div className='iconHolder size-6'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 82 82" fill="none">
                        <path d="M40.625 0C18.207 0 0 18.207 0 40.625C0 63.043 18.207 81.25 40.625 81.25C63.043 81.25 81.25 63.043 81.25 40.625C81.25 18.207 63.043 0 40.625 0ZM40.625 75C21.668 75 6.25 59.582 6.25 40.625C6.25 21.668 21.668 6.25 40.625 6.25C59.582 6.25 75 21.668 75 40.625C75 59.582 59.582 75 40.625 75ZM62.082 23.625C63.414 24.75 63.582 26.707 62.5 28.043L38.207 57.211C37.664 57.879 36.832 58.293 35.957 58.336H35.832C34.9999 58.336 34.207 58.004 33.625 57.418L19.043 42.836C17.836 41.629 17.836 39.629 19.043 38.418C20.25 37.211 22.25 37.211 23.461 38.418L35.629 50.586L57.754 24.043C58.836 22.711 60.836 22.543 62.172 23.6251L62.082 23.625Z" fill="#006666" className='size-full' />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 83 80" fill="none">
                        <path d="M80.7506 56.789L55.0826 8.332C52.3326 3.125 47.1646 0 41.2896 0C35.4146 0 30.2466 3.125 27.4966 8.332L1.82861 56.789C-0.753387 61.664 -0.589387 67.414 2.24658 72.164C5.07858 76.914 10.1216 79.746 15.6216 79.746H66.9146C72.4576 79.746 77.4576 76.914 80.2896 72.164C83.1216 67.414 83.2896 61.664 80.7076 56.789H80.7506ZM74.9615 68.914C73.2545 71.746 70.2545 73.457 66.9185 73.457H15.6255C12.2935 73.457 9.29351 71.75 7.58251 68.914C5.87551 66.082 5.78951 62.621 7.33251 59.707L33.0005 11.25C34.6685 8.125 37.7505 6.25 41.2935 6.25C44.8365 6.25 47.9185 8.125 49.5865 11.25L75.2545 59.707C76.7975 62.625 76.7115 66.082 75.0045 68.914H74.9615ZM44.7935 25.125C46.0865 26.582 46.7115 28.793 46.4185 31.043L44.3755 47.793C44.1685 49.375 42.8325 50.543 41.2935 50.543C39.7505 50.543 38.3755 49.375 38.2115 47.793L36.1685 31.043C35.8755 28.793 36.5005 26.543 37.7935 25.125C39.6685 23 42.9615 23 44.8365 25.125H44.7935ZM44.4185 59.914C44.4185 61.621 43.0005 63.039 41.2935 63.039C39.5865 63.039 38.1685 61.621 38.1685 59.914C38.1685 58.207 39.5865 56.789 41.2935 56.789C43.0005 56.789 44.4185 58.207 44.4185 59.914Z" fill="#FF8C65" className='size-full hidden' />
                    </svg>
                </div>
            ) : (
                <div className='iconHolder size-6'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none">
                        <path d="M4.42651 8.96791C6.85847 4.65597 8.07446 2.5 10.0001 2.5C11.9257 2.5 13.1417 4.65597 15.5736 8.96791L15.8767 9.50522C17.8976 13.0884 18.9081 14.88 17.9949 16.19C17.0816 17.5 14.8221 17.5 10.3031 17.5H9.69703C5.17805 17.5 2.91856 17.5 2.0053 16.19C1.09203 14.88 2.10251 13.0884 4.12346 9.50523L4.42651 8.96791Z" stroke="#FFA526" stroke-width="1.5" />
                        <path d="M10 6.66602V10.8327" stroke="#FFA526" stroke-width="1.5" stroke-linecap="round" />
                        <circle cx="10.0001" cy="13.3333" r="0.5" fill="#FFA526" stroke="#FFA526" stroke-width="0.666667" />
                    </svg>
                </div>)}
            {message}
        </div>
    );
};

export default ToastMessage;

